import Flex from "@/components/Flex";
import Text from "@/components/Text";
import AssessmentDrawer from "@/pages/app/provider/scheduling/appointment/encounter/Assessment/AssessmentDrawer";
import PreviewScreener from "@/pages/app/provider/scheduling/appointment/encounter/default-forms/form-2/ScreenerPreview";
import SectionAccordion from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f/components/SectionAccordion";
import CodeSelectBlock from "./CodeSelectBlock";
import { useScreeningSection } from "../hooks/use-screening-section";
import {
  SCREENING_BLOCK,
  SCREENING_LIST_HEADING,
} from "../initial-f2f-code-constant";
import { CodeItem } from "../initial-f2f-types";

export interface ScreeningSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  customAssessments: CodeItem[];
  onCustomAssessmentsChange: (codes: CodeItem[]) => void;
  freeText: string;
  onFreeTextChange: (value: string) => void;
}

const ScreeningSection = ({
  title,
  expanded,
  onToggle,
  customAssessments,
  onCustomAssessmentsChange,
  freeText,
  onFreeTextChange,
}: ScreeningSectionProps) => {
  const {
    options,
    isLoading,
    setSearchKey,
    screeners,
    hasScreeners,
    modal,
    openScreenings,
  } = useScreeningSection();

  /** Assessments picked from the list open the Add Screening modal; typed ones are kept as written. */
  const handleChange = (next: CodeItem[]) => {
    const added = next.filter(
      (it) => !customAssessments.some((kept) => kept.value === it.value)
    );
    const picked = added.filter((it) => !it.isCustom);
    if (picked.length) openScreenings(picked.map((it) => it.value));
    onCustomAssessmentsChange(next.filter((it) => it.isCustom));
  };

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      showCurrentVisit={false}
    >
      {hasScreeners && (
        <Flex flexDirection="column" width="100%" gap={1}>
          <Text fontWeight="bold" color="#424242">
            {SCREENING_LIST_HEADING}
          </Text>
          <PreviewScreener
            dataListObj={screeners}
            onEdit={(type) => openScreenings([type])}
          />
        </Flex>
      )}
      <CodeSelectBlock
        block={SCREENING_BLOCK}
        isMultiple={false}
        options={options}
        isLoading={isLoading}
        onSearch={setSearchKey}
        codes={customAssessments}
        onCodesChange={handleChange}
        freeText={freeText}
        onFreeTextChange={onFreeTextChange}
      />
      <AssessmentDrawer disclosureHost={modal} />
    </SectionAccordion>
  );
};

export default ScreeningSection;
